import ReactDOM from 'react-dom';
import './index.less';
import * as serviceWorker from './serviceWorker';
import 'antd-mobile/lib/date-picker/style';
import 'antd/dist/antd.css';
import './style/reset.css';

import router from './router';

const ROOT = document.getElementById('root');

if (!ROOT) {
  throw new Error('当前页面不存在 <div id="root"></div> 节点.');
}

ReactDOM.render(router(), ROOT);




